export default "__VITE_ASSET__BRI8n_AR__"